import React, { Component } from "react";
import { Field } from "redux-form";
const divStyle = {
    backgroundColor: '#fff'
};
const padStyle = {
    paddingTop: '5px'
};

class Instruction extends Component {
    renderInput = ({ input, label}) => {
        return (
            <div className="form-group">
                <textarea {...input} autoComplete="new-password" className="form-control" placeholder={label} />
            </div>
        );
    };
    render() {
        return (
            <>
                <div className="form-row col-12 pl-0" style={padStyle}>
                    <div className="col-12" style={divStyle}>
                        <Field name="Instruction" component={this.renderInput} label="Instruction" />
                        </div>
                </div>
            </>
        );
    }

    
}

export default Instruction;